<template>    
    <div class="componente-principal">
        <br/>
        <botao 
            type="button" 
            font_awesome_class="fas fa-users" 
            label="Clientes"
            @click.native="pesquisarClientes()"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-address-book" 
            label="Fornecedores"
            @click.native="pesquisarFornecedores()"/>
    </div>
</template>

<script>

import Botao from '@/components/shared/Botao.vue';

export default {
    name: 'Cadastros',
    components: {
        Botao
    },
    
    methods:{
        pesquisarClientes() {
            this.$router.push('/pesquisarclientes');
            
        },
        pesquisarFornecedores() {
            this.$router.push('/pesquisarfornecedores');
        }
    }

}
</script>

<style scoped>

</style>